import React from "react";
import { LabeledText, Stack } from "sprint-common-web";

import { AncillaryComponentRenderer } from "../../../../common/components/AncillaryComponentRenderer";
import { MovieComponentRenderer } from "../../../../common/components/MovieComponentRenderer";
import { TvSeriesComponentRenderer } from "../../../../common/components/TvSeriesComponentRenderer";
import { FileRecordDetails } from "../FileRecordDetails";
import { FileRecordAncillaryContentView } from "./ancillary/FileRecordAncillaryContentView";
import { FileRecordMovieContentView } from "./movie/FileRecordMovieContentView";
import { FileRecordTvSeriesContentView } from "./tv-series/FileRecordTvSeriesContentView";

interface FileRecordContentViewProps {
    fileRecordDetails: FileRecordDetails;
}

export const FileRecordContentView = ({ fileRecordDetails }: FileRecordContentViewProps): JSX.Element => {
    return (
        <>
            {fileRecordDetails.content ? (
                <Stack>
                    <MovieComponentRenderer subtype={fileRecordDetails.content.contentSubtype}>
                        <FileRecordMovieContentView fileRecordDetails={fileRecordDetails} />
                    </MovieComponentRenderer>
                    <TvSeriesComponentRenderer subtype={fileRecordDetails.content.contentSubtype}>
                        <FileRecordTvSeriesContentView fileRecordDetails={fileRecordDetails} />
                    </TvSeriesComponentRenderer>
                    <AncillaryComponentRenderer subtype={fileRecordDetails.content.contentSubtype}>
                        <FileRecordAncillaryContentView fileRecordDetails={fileRecordDetails} />
                    </AncillaryComponentRenderer>
                </Stack>
            ) : (
                <Stack>
                    <LabeledText label="Content" testId="content-field">
                        -
                    </LabeledText>
                </Stack>
            )}
        </>
    );
};
